module.exports = __webpack_public_path__ + "img/usuario__active.29bfe621.svg";